import { Card } from "../../../lib/components/ui/card";
import { Skeleton } from "../../../lib/components/ui/skeleton";

export function MenuItemsSkeleton() {
	return (
		<div className="space-y-6">
			<div className="flex items-center justify-between">
				<Skeleton className="h-8 w-32" />
				<Skeleton className="h-10 w-32" />
			</div>
			<Card className="p-6">
				<div className="flex gap-4">
					<Skeleton className="h-10 flex-1" />
					<Skeleton className="h-10 w-32" />
					<Skeleton className="h-10 w-32" />
				</div>
			</Card>
			<div className="grid mt-24 grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-10 gap-y-24">
				{Array.from({ length: 8 }).map((_, i) => (
					<Card
						key={i}
						className="relative overflow-visible rounded-2xl p-6 bg-card flex flex-col h-full"
					>
						<div className="flex-1 flex flex-col gap-4">
							<div className="absolute -top-18 right-10 flex justify-center z-10">
								<div className="size-36 md:size-40 rounded-full bg-background shadow-md flex items-center justify-center">
									<Skeleton className="size-32 md:size-36 rounded-full" />
								</div>
							</div>

							<div className="flex flex-col gap-2 mb-4">
								<div className="flex flex-col gap-1">
									<Skeleton className="h-6 w-3/4" />
									<Skeleton className="h-4 w-24" />
								</div>
								<div className="flex items-center gap-2 mt-1">
									<Skeleton className="h-4 w-20" />
									<Skeleton className="h-4 w-10" />
								</div>
								<div className="space-y-2 mt-2">
									<Skeleton className="h-4 w-full" />
									<Skeleton className="h-4 w-2/3" />
								</div>
							</div>
						</div>

						<div className="flex flex-col gap-4">
							<div className="flex items-center gap-2">
								<Skeleton className="h-6 w-20 rounded-full" />
								<Skeleton className="h-6 w-24 rounded-full" />
							</div>

							<div className="flex items-center justify-between">
								<Skeleton className="h-8 w-16" />
								<Skeleton className="h-9 w-20" />
							</div>
						</div>
					</Card>
				))}
			</div>
		</div>
	);
}
